<template>
  <div class="map-container">

    <div :id="'map-' + _uid" class="map-view"/>

    <div v-if="internalLoading || loading" class="map-progress-container text-xs-center">
      <v-progress-circular indeterminate size="60" width="5" color="white"/>
    </div>

    <div v-else-if="!map" class="map-error-container text-xs-center display-2 white--text pa-3">
      {{ $t('errori.caricamento_mappa') }}
    </div>

    <template v-if="map">
      <slot/>
    </template>

  </div>
</template>

<script>
import GmapMarker from '@/components/gmap/GmapMarker'

export default {
    name: 'Gmap',
    components: { GmapMarker },
    provide () {
        let provider = {
            calcRoute: this.calcRoute,
            markerService: {
                register: this.registerMarker,
                unregister: this.unregisterMarker
            },
            openInfoWindow: this.openInfoWindow
        }

        //  Per rendere "map" reactive anche negli inject dei child
        Object.defineProperties(provider, {
            map: {
                get: () => this.map
            }
        })

        return provider
    },
    props: {
        loading: false
    },
    data: () => ({
        map: null,
        directionsService: null,
        markers: [],
        routes: [],
        infoWindow: null,

        userPosition: null,
        internalLoading: false
    }),
    mounted () {
        this.internalLoading = true
        //  Caricamento posizione utente
        this.loadUserPosition()
        this.$loadGmap().then(() => {
            //  Caricamento mappa
            this.map = new this.$google.maps.Map(this.$el.querySelector('#map-' + this._uid), {
                center: this.currentPosition || { lat: 45, lng: 11 },
                zoom: 7,
                streetViewControl: false
            })
            //  Caricamento service per calcolo routes
            this.directionsService = new this.$google.maps.DirectionsService()
            //  Nuova istanza per infoWindow
            this.infoWindow = new this.$google.maps.InfoWindow({
                content: '<div></div>'
            })
            this.internalLoading = false
        })
    },
    watch: {
        markers (val) {
            if (this.map) {
                if (val.length > 1) {
                    let bounds = new this.$google.maps.LatLngBounds()
                    for (let marker of val) {
                        bounds.extend(new this.$google.maps.LatLng(marker.lat, marker.lng))
                    }
                    this.map.fitBounds(bounds)
                } else {
                    if (val.length > 0) this.map.panTo(val[0])
                }
            }
        }
    },
    methods: {
        registerMarker (id, position) {
            //  Registro il marker in modo da poter fare uno zoom automatico della mappa
            this.markers.push({ id, ...position })
        },
        unregisterMarker (id) {
            //  Rimouvo il marker dagli elementi registrati
            let index = this.markers.findIndex(marker => marker.id === id)
            if (index !== -1) this.markers.splice(index, 1)
        },
        openInfoWindow (marker, content) {
            this.infoWindow.setContent(content)
            this.infoWindow.open(this.map, marker)
        },
        calcRoute (options, callback) {
            if (this.directionsService) {
                this.directionsService.route(options, callback)
            }
        },
        setCenter (position) {
            this.map.panTo(position)
        },
        loadUserPosition () {
            if (navigator.geolocation) {
                this.internalLoading = true
                navigator.geolocation.getCurrentPosition(position => {
                    this.userPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                    this.internalLoading = false
                })
            }
        }
    }
}
</script>
<style scoped lang="scss">

  .map-container, .map-view {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .map-progress-container, .map-error-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);

    .v-progress-circular {
      position: absolute;
      top: calc(50% - 30px);
      left: calc(50% - 30px);
    }

  }
</style>
